/**
 * オーダ用の認証
 */
import * as httpConst from '../../../constants/httpConst'
import Vue from 'vue'
import * as types from '../../mutation-types/driver-types'
import store from 'store'
import dayjs from "dayjs";

const isDriverLoggedIn = () => {
  return (store.get('driverLoggedIn') !== undefined)
}

const getCurrentUser = () => {
  const default_current_user = {
    id: null,
    name: null,
    login_id: null,
  }
  let current_user = null
  if (isDriverLoggedIn()) current_user = store.get('driverCurrentUser')
  return (current_user) ? current_user : default_current_user
}
const API_PATH = `${httpConst.DRIVER_BASE}/api/oauth`
const authentication = {
  namespaced: true,
  state: {
    token: null,
    demo: false,
    jwMode: false,
    driverUser: null,
    currentTenant: {},
    loggedIn: isDriverLoggedIn(),
    name: getCurrentUser().name,
    expiresTime: null,
    use_allocate: true,
  },
  getters: {
    accessToken: (state) => {
      return state.token;
    },
    alive: (state) => {
      if (!state.expiresTime) {
        return false;
      }
      return dayjs().unix() < state.expiresTime;
    },
    driverUser: (state) => {
      return state.driverUser
    },
    /**
     * デモ環境判定
     * @param state
     * @return { boolean }
     */
    isDemoEnv: (state) => {
      return state.demo
    },
    tenantId: (state) => {
      return (state.currentTenant) ? state.currentTenant.id : null
    },
    tenantName: (state) => {
      return (state.currentTenant) ? state.currentTenant.name : null
    },
    userId: (state) => {
      return (state.driverUser) ? state.driverUser.id : null
    },
    userName: ( state ) => {
      return (state.driverUser) ? state.driverUser.name : null
    },
    loginId: (state) => {
      return (state.driverUser) ? state.driverUser.login_id : null
    },
    driverExpiresTime: (state) => {
      return (state.expiresTime) ? state.expiresTime : null
    },
    isSuperAdminUser: (state) => {
      return (state.driverUser) ? (state.driverUser.role === 'super_user') || (state.driverUser.role === 'admin_user') : false
    },
    isSuperSupportUser: (state) => {
      return (state.driverUser) ? (state.driverUser.role === 'super_user' || state.driverUser.role === 'support_user') : false
    },
    isJwMode: (state) => {
      return state.jwMode
    },
  },
  actions: {
    signInDriver ({ commit }, { params }) {
      const fixedParams = {
        grant_type: 'password',
        client_id: process.env.VUE_APP_DRIVER_CLIENT_ID,
        client_secret: process.env.VUE_APP_DRIVER_CLIENT_SECRET,
        scope: process.env.VUE_APP_DRIVER_SCOPE
      }
      const parameter = { ...params, ...fixedParams }
      return new Promise((resolve) => {
        const api_path = `${API_PATH}/token`
        Vue.$http.post(api_path, parameter).then( data => {
          let content = data.content
          let params = {
            access_token: content.access_token,
            user: content.user,
            tenant: content.tenant,
            refresh_token: content.refresh_token,
            created_at: content.created_at,
            expires_in: content.expires_in,
            demo: content.demo,
            jw_mode: content.jw_mode,
          }
          commit(types.DRIVER_SIGN_IN, { params: params} )
          resolve(content)
        })
      })
    },
    signOutDriver ({ commit }) {
      const api_path = `${API_PATH}/revoke`
      return new Promise((resolve) => {
        Vue.$http.post(api_path).then( data => {
          commit(types.DRIVER_SIGN_OUT)
          resolve(data)
        })
      })
    },
    switchTenant ({ commit }, { tenant }) {
      commit(types.DRIVER_SWITCH_TENANT, { tenant: tenant })
    },
  },
  mutations: {
    [types.DRIVER_SWITCH_TENANT] (state, { tenant }) {
      state.currentTenant = tenant
      store.set('driverCurrentTenant', state.currentTenant)
    },
    forceSignOut (state) {
      state.token = null
      state.driverUser = null
      state.currentTenant = null
      state.expiresTime = null
      state.demo = false
      state.jwMode = false
      store.remove('token')
      store.remove('driverLoggedIn')
      store.remove('driverCurrentUser')
      store.remove('driverCurrentTenant')
      store.remove('driverExpiresTime')
    },
    [types.DRIVER_SIGN_IN] (state, { params }) {
      state.token = params.access_token
      state.driverUser = params.user
      state.currentTenant = params.tenant
      const loggedInTime = dayjs.unix(params.created_at)
      const expiresTime  = loggedInTime.add(params.expires_in, 'seconds').unix() * 1000
      state.expiresTime = expiresTime
      state.demo = params.demo
      state.jwMode = params.jw_mode
      // localStorageに保持
      store.set('driverLoggedIn', true)
      store.set('driverCurrentUser', params.user)
      store.set('driverCurrentTenant', params.tenant)
      store.set('driverExpiresTime', expiresTime)
    },
    [types.DRIVER_SIGN_OUT] (state) {
      state.token = null;
      state.driverUser = null
      state.currentTenant = null
      state.expiresTime = null
      state.demo = false
      state.jwMode = false
      // localStorageに保持
      store.remove('token')
      store.remove('expiresTime')
      store.remove('driverLoggedIn')
      store.remove('driverCurrentUser')
      store.remove('driverCurrentTenant')
      store.remove('driverExpiresTime')
    },
  },
}

export default authentication
